import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import RuleHistoryDialog from './history_dialog';

/*
 * "Rule: <name> v<no>, from <date>" under a pay or penalty line the rules engine worked out; it
 * opens that rule's history with the line's version marked.
 */
const RuleRefLink = ({ rule_ref, on_error }) => {
  const [open, setOpen] = useState(false);
  if (!rule_ref) return null;
  return (
    <>
      <button
        type="button"
        className="tp-link tp-rx-ref"
        title="Show this rule's history"
        onClick={() => setOpen(true)}
      >
        {rule_ref.text}
      </button>
      {open
        ? createPortal(
            <RuleHistoryDialog
              rule_key={rule_ref.rule_key}
              highlight_version_id={rule_ref.version_id}
              on_close={() => setOpen(false)}
              on_error={on_error}
            />,
            document.body
          )
        : null}
    </>
  );
};

export default RuleRefLink;
